import { environment } from '../utils/constants';

export const redirect = (url: string) => {

    let baseUri = '/' + window.location.pathname.split('/')[1] + '/';
    console.log("🚀 console.log ~ ~ redirect ~ baseUri:", baseUri)

    const currentUrl = window.location.href;
    console.log("🚀 console.log ~ ~ redirect ~ currentUrl:", currentUrl)

    if (currentUrl.startsWith('https://endurance') || currentUrl.startsWith('https://batavia')) {
        baseUri = baseUri + window.location.pathname.split('/')[2] + '/';
    }

    if (currentUrl.startsWith('http://localhost')) {
        baseUri = `${environment.baseUri}`;
    }

    const attachIdToApplicationUrl = url.slice(0, 11) === 'application' ? `id/${url}` : `${url}`;
    console.log("🚀 console.log ~ ~ redirect ~ attachIdToApplicationUrl:", attachIdToApplicationUrl)
    return `${baseUri}${attachIdToApplicationUrl}`;
};
